var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E95832",
    d: "M8 2h4c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1Zm2 5c-.51 0-.92.39-.98.89L11 9.86V8c0-.55-.45-1-1-1Zm0-2c3.87 0 7 3.13 7 7 0 1.12-.27 2.18-.74 3.12l1.47 1.47C18.53 15.25 19 13.68 19 12c0-2.12-.74-4.07-1.97-5.61l.75-.75a.993.993 0 0 0 0-1.4l-.01-.01a.993.993 0 0 0-1.4 0l-.75.75A8.962 8.962 0 0 0 10 3c-1.66 0-3.22.48-4.57 1.29l1.45 1.45C7.82 5.27 8.88 5 10 5Zm8.19 14.88L1.87 3.56A.996.996 0 1 0 .46 4.97l2.07 2.07C1.61 8.42 1.05 10.03 1 11.76A8.998 8.998 0 0 0 10 21c1.84 0 3.55-.55 4.98-1.5l1.79 1.79c.39.39 1.02.39 1.41 0 .4-.39.4-1.02.01-1.41ZM10 19c-3.87 0-7-3.13-7-7 0-1.29.35-2.49.96-3.52l9.57 9.57c-1.04.6-2.24.95-3.53.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmOff);
export default __webpack_public_path__ + "static/media/alarm-off.b20d6f32a57ab27bba65ed489ac89daa.svg";
export { ForwardRef as ReactComponent };